export * from './information-panel.component';
